import React, { Component } from "react";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import { connect } from "react-redux";
import RingLoader from "react-spinners/ScaleLoader";
import { Link } from "react-router-dom";
import moment from "moment";

//componentes
import "./boletin.css";
import Alert from "../../modal/alert";

class BoletinA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cedulaAlumno: "",
      trimestre: "",
      anoEscolar: moment().format("YYYY"),
      icedulaH: [],
      mensajealerta: false,
      loading: false,
      boletaM: "0",
      botonOn: false,
      itrimestre: [],
      trimestreN:''
    };
  }
  limpiar = () => {
    this.setState({
      cedulaAlumno: "",
      trimestre: "",
      anoEscolar: moment().format("YYYY"),
      icedulaH: [],
      mensajealerta: false,
      loading: false,
      boletaM: "0",
      botonOn: false,
      trimestreN:''
    });
  };

  trimestresAnioActual = () => {
    return this.state.itrimestre.filter(
      (item) => String(item.variable3) === String(this.state.anoEscolar)
    );
  };

  obtenerCodigosTrimestre = () => {
    let codoTri1 = 0;
    let codoTri2 = 0;
    let codoTri3 = 0;
    let tri1 = 0;
    let tri2 = 0;
    let tri3 = 0;
    this.trimestresAnioActual().forEach((item, i) => {
      if (i === 0) {
        codoTri1 = item.variable1;
        tri1 = item.variable2;
      }
      if (i === 1) {
        codoTri2 = item.variable1;
        tri2 = item.variable2;
      }
      if (i === 2) {
        codoTri3 = item.variable1;
        tri3 = item.variable2;
      }
    });
    return { codoTri1, codoTri2, codoTri3, tri1, tri2, tri3 };
  };

  onChange(e) {
    let index = e.target.getAttribute("id");
    const element=e.target;
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });

    if (index === "trimestre"){
      const selectedIndex = element.selectedIndex;
      const selectedText = element.options[selectedIndex].text;
      this.setState({ trimestreN: selectedText.substring(1, 2) });
    }
  }

  onChange2 = (e) => {
    let index = e.target.getAttribute("id");
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
    if (index === "cedulaAlumno") {
      this.VerificarGrado(e.target.value);
    }
    if (index === "idtarea" && e.target.value.length > 0) {
      this.consultarAdjuntos(e.target.value);
      this.setState({ enviarOn: true, adjuntarOn: false });
    }
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  VerificarGrado = (e) => {
    let form = new FormData();
    form.append("anoEscolar", this.state.anoEscolar);
    form.append("cedulaAlumno", e);
    form.append("boton", "VerificarGrado");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/backend/reportePlanificacion.php";
    axios.post(xurl, form, config).then((res) => {
      let xialumno = res.data.variable2;
      if (res.data.variable1) {
        this.setState({ boletaM: res.data.variable2 });
      } else {
        this.setState({
          boletaM: res.data.variable2,
        });
      }
    });
  };

  buscarAlumno = () => {
    let form = new FormData();
    form.append("clave", this.props.usuario1.password);
    form.append("boton", "buscarAlumnos");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/backend/reportePlanificacion.php";
    axios.post(xurl, form, config).then((res) => {
      let xialumno = res.data.variable2;
      this.setState({
        icedulaH: xialumno,
      });
    });
  };

  habilitarBoletin = () => {
    this.setState({ loading: true });
    const { codoTri1, codoTri2, codoTri3, tri1, tri2, tri3 } =
      this.obtenerCodigosTrimestre();
    let form = new FormData();
    form.append("cedulaAlumno", this.state.cedulaAlumno);
    form.append("trimestre", this.state.trimestreN);
    form.append("trimestre1", tri1);
    form.append("codtrimestre1", codoTri1);
    form.append("trimestre2", tri2);
    form.append("codtrimestre2", codoTri2);
    form.append("trimestre3", tri3);
    form.append("codtrimestre3", codoTri3);
    form.append("boton", "buscarAB");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/backend/habilitarBoletin.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1) {
        console.log(this.state.boletaM);
        if (this.state.boletaM === 0) {
          this.gradoAcudiente();
          this.setState({
            loading: false,
            botonOn: true,
            mensajealerta: true,
            tituloM: "Menu de Boletines",
            cuerpoM:
              "Por favor Espere Mientras se Muestra el Boletin, Gracias...",
          });
        }
        if (this.state.boletaM === 1) {
          this.imprimirBM();
          this.setState({
            loading: false,
          });
        }
      } else {
        this.setState({
          loading: false,
          mensajealerta: true,
          tituloM: "Menu Boletines",
          cuerpoM:
            "El Boletin Aún no esta Autorizado, Por Favor Comuniquese con Administración gracias...",
        });
      }
    });
  };

  gradoAcudiente = () => {
    this.setState({ loading: true });
    const { codoTri1, codoTri2, codoTri3, tri1, tri2, tri3 } =
      this.obtenerCodigosTrimestre();
    let form = new FormData();
    form.append("cedulaAlumno", this.state.cedulaAlumno);
    form.append("trimestre", this.state.trimestreN);
    form.append("trimestre1", tri1);
    form.append("codtrimestre1", codoTri1);
    form.append("trimestre2", tri2);
    form.append("codtrimestre2", codoTri2);
    form.append("trimestre3", tri3);
    form.append("codtrimestre3", codoTri3);
    form.append("boton", "gradosAcudiente");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl = "https://institutobilinguelasnaciones.com/backend/grado.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1) {
        this.reporteCanvas(res.data.variable2);
        //console.log(res.data.variable2);
        this.setState({ loading: false });
      } else {
        this.setState({
          loading: false,
          mensajealerta: true,
          tituloM: "Menu Boletines",
          cuerpoM:
            "El Alumno no tiene un grado asignado, por favor Comuniquese con Administración gracias...",
        });
      }
    });
  };

  imprimirBM = () => {
    if (this.state.cedulaAlumno.length > 0 && this.state.trimestre.length > 0) {
      const { codoTri1, codoTri2, codoTri3, tri1, tri2, tri3 } =
        this.obtenerCodigosTrimestre();
      let data = new FormData();
      data.append("trimestre", this.state.trimestre);
      data.append("cedulaAlumno", this.state.cedulaAlumno);
      data.append("anoEscolar", this.state.anoEscolar);
      data.append("trimestre1", tri1);
      data.append("codtrimestre1", codoTri1);
      data.append("trimestre2", tri2);
      data.append("codtrimestre2", codoTri2);
      data.append("trimestre3", tri3);
      data.append("codtrimestre3", codoTri3);

      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/fpdf/reportes/boletinMaternalesR.php",
        responseType: "arraybuffer",
        data: data,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Imprimir Boletines.",
        cuerpoM: "Debe indicar el Alumno y Trimestre.",
      });
    }
  };

  imprimirBoletin = () => {
    if (this.state.cedulaAlumno.length > 0 && this.state.trimestre.length > 0) {
      const { codoTri1, codoTri2, codoTri3, tri1, tri2, tri3 } =
        this.obtenerCodigosTrimestre();
      let data = new FormData();
      data.append("cedulaAlumno", this.state.cedulaAlumno);
      data.append("anoEscolar", this.state.anoEscolar);
      data.append("trimestre", this.state.trimestre);
      data.append("trimestre1", tri1);
      data.append("codtrimestre1", codoTri1);
      data.append("trimestre2", tri2);
      data.append("codtrimestre2", codoTri2);
      data.append("trimestre3", tri3);
      data.append("codtrimestre3", codoTri3);



      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/fpdf/reportes/boletin2.php",
        responseType: "arraybuffer",
        data: data,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu de Reportes",
        cuerpoM: "Debe seleccionar a el Alumno gracias...",
        listaOn: false,
      });
    }
  };

  reporteCanvas = async (e) => {
    this.setState({
      loading: true,
    });
    const { codoTri1, codoTri2, codoTri3, tri1, tri2, tri3 } =
      this.obtenerCodigosTrimestre();
    let data = new FormData();
    data.append("claveUsuario", this.props.usuario1.password);
    data.append("grado", e);
    data.append("trimestre", this.state.trimestre);
    data.append("cedulaAlumno", this.state.cedulaAlumno);
    data.append("trimestre1", tri1);
    data.append("codtrimestre1", codoTri1);
    data.append("trimestre2", tri2);
    data.append("codtrimestre2", codoTri2);
    data.append("trimestre3", tri3);
    data.append("codtrimestre3", codoTri3);
    data.append("boton", "alumnosmateriasAcudiente");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl = "https://institutobilinguelasnaciones.com/backend/token.php";
    let res = await axios.post(xurl, data, config);

    //console.log("paso "+res.data.variable2)
    let xifechamedi1 = res.data;
    if (res.data.variable1 === true) {
      console.log(xifechamedi1);
      this.setState({
        loading: false,
      });
      //this.reporteCanvas2(e);
      this.imprimirBoletinCanvas(e);
    }
  };

  reporteCanvas2 = async (e) => {
    this.setState({
      loading: true,
    });
    let data = new FormData();
    data.append("claveUsuario", this.props.usuario1.password);
    data.append("grado", e);
    data.append("boton", "notas");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl = "https://institutobilinguelasnaciones.com/backend/token.php";
    let res = await axios.post(xurl, data, config);

    //console.log("paso "+res.data.variable2)
    let xifechamedi1 = res.data;
    if (res.data.variable1 === true) {
      console.log(xifechamedi1);
      this.setState({
        loading: false,
        botonOn: false,
        mensajealerta: false,
      });
      this.imprimirBoletinCanvas(e);
    }
  };

  imprimirBoletinCanvas = (e) => {
    const { codoTri1, codoTri2, codoTri3, tri1, tri2, tri3 } =
      this.obtenerCodigosTrimestre();
    let data = new FormData();
    data.append("idcurso", e);
    data.append("idcurso3", e);
    data.append("anoEscolar", this.state.anoEscolar);
    data.append("trimestre", this.state.trimestre);
    data.append("trimestreC", this.state.trimestreN);
    data.append("trimestre1", tri1);
    data.append("codtrimestre1", codoTri1);
    data.append("trimestre2", tri2);
    data.append("codtrimestre2", codoTri2);
    data.append("trimestre3", tri3);
    data.append("codtrimestre3", codoTri3);
    data.append("claveUsuario", this.props.usuario1.password);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/fpdf/reportes/boletinCanvas.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  cargarTrimestreCanvas = async () => {
    let data = new FormData();
    data.append("boton", "trimestreCanvas");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl = "https://institutobilinguelasnaciones.com/backend/token.php";
    let res = await axios.post(xurl, data, config);

    if (res.data.variable1) {
      let xicursos2 = res.data.variable2;
      this.setState({
        itrimestre: xicursos2,
      });
    }
  };

  a = () => {};
  componentDidMount() {
    // this.buscarAnioEscolar();
    // this.cargarFechas();
    this.cargarTrimestreCanvas();
    this.buscarAlumno();
  }
  render() {
    return (
      <div className="cont-servi-principalx row">
        <div className="eslogan1su1 col-12">
          <div className="titulo-cxc ">
            <p>GENERAR BOLETINES. </p>
          </div>

          {this.state.loading && (
            <div className="cont-spinner row">
              <div className="spinner col-6">
                <RingLoader
                  clasName="spinner"
                  sizeUnit={"px"}
                  size={160}
                  width={19}
                  radius={20}
                  height={160}
                  color={"#48e120"}
                  loading={this.state.loading}
                />
              </div>
            </div>
          )}

          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
              eliminar={this.state.elimi}
              handleEliminar={this.handleEliminar}
            />
          )}

          <div className="historia-contenidoant">
            <div className="form-groupev col-12">
              <div className="row">
                <div className="cont-personal col-12">
                  <div className="contenedorcedula1f col-3">
                    <select
                      id="cedulaAlumno"
                      name="cedulaAlumno"
                      value={this.state.cedulaAlumno}
                      onChange={this.onChange2.bind(this)}
                    >
                      <option>-- Seleccione el Alumno --</option>
                      {this.state.icedulaH.map((item, i) => {
                        return (
                          <option key={i} value={item.variable1}>
                            {item.variable2}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="contenedorcedula1f col-2">
                    <select
                      id="trimestre"
                      name="trimestre"
                      value={this.state.trimestre}
                      onChange={this.onChange.bind(this)}
                    >
                      <option>-- TRIMESTRE --</option>
                      {this.trimestresAnioActual().map((item, i) => {
                        return (
                          <option key={i} value={item.variable1}>
                            {item.variable2}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="contenedorcedula1f col-12">
                  <div className="acciones">
                    {!this.state.botonOn && (
                      <button
                        className="boton"
                        onClick={this.habilitarBoletin.bind(this)}
                      >
                        Imprimir Boletin
                      </button>
                    )}
                    <Link to="/">
                      <button className="boton">Salir</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};

export default connect(mapStateToProps)(BoletinA);
